import React from 'react';

import PropTypes from 'prop-types';

import { FieldLabel } from '../css';

const FieldTitle = ({ required, label, isLabelBold }) => {
  return (
    <>
      <FieldLabel style={isLabelBold ? { fontWeight: 'bold' } : {}}>
        <span style={{ display: 'flex', gap: '0.25rem' }}>
          {label}
          {required && ' *'}
        </span>
      </FieldLabel>
    </>
  );
};

FieldTitle.propTypes = {
  required: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  isLabelBold: PropTypes.bool
};

export default FieldTitle;
